import { Navigate } from "react-router-dom";
import { useUserRole } from "../../../hooks/useUserRole";
import { Proofing } from "./index";
import { ViewAsWrapper } from "./ViewAsWrapper";

/**
 * Route switch: renders ViewAsWrapper for admins, Proofing for reps.
 * The admin sees the "View as..." UI; the rep sees the normal proofing list.
 */
export function ProofingRouteSwitch() {
  const { isAdmin, isRep, loading } = useUserRole();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (isAdmin) return <ViewAsWrapper />;
  if (isRep) return <Proofing />;

  return <Navigate to="/" replace />;
}
